import { GenericListItem } from '@/models'
import { TIPO_IMOVEL } from './TipoImovel'

export const TIPO_IMOVEL_LISTA = [
	new GenericListItem({ id: TIPO_IMOVEL.RESIDENCIAL, description: 'Residencial', img: '/vectors/tipo-imovel-residencial.svg' }),
	new GenericListItem({ id: TIPO_IMOVEL.COMERCIAL, description: 'Comercial', img: '/vectors/tipo-imovel-comercial.svg' }),
	new GenericListItem({
		id: TIPO_IMOVEL.TERRENO,
		description: 'Terreno',
		img: '/vectors/tipo-imovel-terreno.svg',
		message: 'Somente o bradesco trabalha com terreno'
	})
]
